import React, { createContext, useRef, useState } from 'react';

export const DragContext = createContext({
  iconRef: null,
  tooltipRef: null,
  draggedNodes: [],
  setDraggedNodes: null,
});

export const DragContextProvider = ({ children }) => {
  const iconRef = useRef(null);
  const tooltipRef = useRef(null);
  const [draggedNodes, setDraggedNodes] = useState<any[]>(null);

  return (
    <DragContext.Provider value={{ iconRef, tooltipRef, draggedNodes, setDraggedNodes }}>
      {children}
    </DragContext.Provider>
  );
};
